import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../../config/config';

import {  catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
@Injectable()
export class ReporteDinamicoService {
  dataUrl = Config.URL_BASE + '/reporte_dinamico';
/**
 * 
 * select public.ctb_reporte_balance_general_din(
	2025,
	1,
	16);
	
select public.ctb_reporte_balanza_comprobacion_din(
	2025,
	1,
	16);
	
	
select public.ctb_reporte_estado_resultados_din(
	2025,
	1,
	16);
 */
  constructor(private http: HttpClient) { }

    ctb_reporte_balance_general_din(_year: number,_month: number,_gral_emp_id: number): Observable<any> {
      let url_ = this.dataUrl + '/balance_general/'+_year+'/'+_month+'/'+_gral_emp_id+'';
      url_ = url_.replace(/[?&]$/, '');
      return this.http.get(url_).pipe(
        catchError(e => {
          console.log(e);
          return throwError(e);
        })
      );
    }
       ctb_reporte_balanza_comprobacion_din(_year: number,_month: number,_gral_emp_id: number): Observable<any> {
      let url_ = this.dataUrl + '/balanza_comprobacion/'+_year+'/'+_month+'/'+_gral_emp_id+'';
      url_ = url_.replace(/[?&]$/, '');
      return this.http.get(url_).pipe(
        catchError(e => {
          console.log(e);
          return throwError(e);
        })
      );
    }
       ctb_reporte_estado_resultados_din(_year: number,_month: number,_gral_emp_id: number): Observable<any> {
      let url_ = this.dataUrl + '/estado_resultados/'+_year+'/'+_month+'/'+_gral_emp_id+'';
      url_ = url_.replace(/[?&]$/, '');
      return this.http.get(url_).pipe(
        catchError(e => {
          console.log(e);
          return throwError(e);
        })
      );
    }
}
